/**
 * Tank-wise fuel stock breakdown — portal modal (same pattern as bank/tank modals).
 */
import React from "react";
import ReactDOM from "react-dom";

const FuelDetailModal = ({ isOpen, onClose, fueldata = [] }) => {
  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <>
      <div
        className="modal-overlay emp-fuel-detail-overlay"
        onClick={onClose}
        role="presentation"
      />
      <div className="modal-wrapper emp-fuel-detail-wrapper" role="dialog" aria-modal="true" aria-label="Fuel details">
        <div className="modal modal-dialog">
          <div className="modal-content">
            <div className="modal-title modal-header">
              <h5 className="modal-title">Fuel Details</h5>
              <button type="button" onClick={onClose} className="btn-close" aria-label="Close" />
            </div>
            <div className="table-widget">
              <table className="table border mb-0">
                <thead>
                  <tr>
                    <th>Tank Name</th>
                    <th>Capacity (KL)</th>
                    <th>Stock (L)</th>
                    <th>WAC Purchase (₹/L)</th>
                    <th>Fill %</th>
                  </tr>
                </thead>
                <tbody>
                  {fueldata.map((obj, index) => (
                    <tr key={`fuel-${obj.id || obj.tank_id || index}`}>
                      <td>{obj.tank_name}</td>
                      <td>{Number(obj.capacity || 0).toLocaleString("en-IN")}</td>
                      <td>
                        {Number(obj.current_stock || 0).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {Number(obj.wac_purchase_price || 0).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {obj.percent != null ? `${obj.percent}%` : "—"}
                        {obj.is_overfill ? " (overfill)" : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default FuelDetailModal;
